import { useState } from 'react'
import { Form, InputGroup, Modal } from 'react-bootstrap'

import { unlockBodyPosition } from 'components/common/navigation/Header/Header';
import Search from 'components/search/Search';

export default function SearchInput({ returnPath = null }) {
  const [showSearchModal, setShowSearchModal] = useState(false);

  return (
    <div className='search'>
      <InputGroup>
        <Form.Control
          type='text'
          id='search'
          placeholder='Search by topic or activity'
          onClick={e => {
            setShowSearchModal(true)
            e.target.blur()
          }}
        />
      </InputGroup>

      <Modal
        show={showSearchModal}
        onHide={_ => unlockBodyPosition() && setShowSearchModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Search
            hideHandler={_ => unlockBodyPosition() && setShowSearchModal(false)}
            returnPath={returnPath}
          />
        </Modal.Body>
      </Modal>
    </div>
  )
}